webpackJsonp([158263661751279],{

/***/ 1360:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AssignOrphanTransactionInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":"The adjusted quantity for the clinical item. If not provided, the transaction quantity will be used.","name":"adjustedItemQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"patientId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-assign-orphan-transaction-input-403a9641388fc31c6a1a.js